export default "__VITE_PUBLIC_ASSET__fb4cbdfd__"